import {
  REQUESTED_APPLICATION_LIST,
  REQUESTED_APPLICATION_LIST_SUCCEEDED,
  REQUESTED_APPLICATION_LIST_FAILED,
} from "./types"

export const requestAppList = config => {
  return { type: REQUESTED_APPLICATION_LIST, config }
}

export const requestAppListSuccess = (action, response) => {
  return { type: REQUESTED_APPLICATION_LIST_SUCCEEDED, action, response }
}

export const requestAppListError = (action, error) => {
  return { type: REQUESTED_APPLICATION_LIST_FAILED, action, error }
}
